import { query } from '@rexlabs/model-generator';
import pagesModel from 'data/models/entities/pages';

export const pagesQuery = query`{
  ${pagesModel} (websiteId: ${(p) => p?.match?.params?.websiteId}) {
    id
    title
  }
}`;
